export function noScriptTags() {
  const noscriptYandex = document.createElement('noscript');
  noscriptYandex.innerHTML = `
    <div><img src="https://mc.yandex.ru/watch/96220292"  style="position:absolute; left:-9999px;" alt="" /></div>
  `;

  const noscriptMailRu = document.createElement('noscript');
  noscriptMailRu.innerHTML = `
    <div><img src="https://top-fwz1.mail.ru/counter?id=3259545;js=na" style="position:absolute;left:-9999px;" alt="Top.Mail.Ru" /></div>
  `;

  const noscriptGTM = document.createElement('noscript');
  noscriptGTM.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PVBDZGCG"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;

  document.body.appendChild(noscriptYandex);
  document.body.appendChild(noscriptMailRu);
  document.body.appendChild(noscriptGTM);
}
